module.exports = __webpack_public_path__ + "img/card2.78b7b016.jpg";